<template>
  <sp-button
    ref="button"
    class="sp-finder-result-other-locations-toggle"
    :class="classModifiers"
    variant="flat"
    color="default"
    size="small"
    :data-testid="TestId.finder.otherLocationsToggle"
    :aria-expanded="ariaExpanded"
    @click="handleClick"
  >
    {{ label }}
    <sp-icon
      slot="append"
      class="sp-finder-result-other-locations-toggle__icon"
      name="popup-arrow-filled"
      size="x-small"
    ></sp-icon>
  </sp-button>
</template>

<script setup>
import { computed, useTemplateRef } from "vue";
import { TestId } from "#/test-ids";
import { useAriaControls } from "#ce/composables/useAriaControls";
import { i18n } from "#ce/components/SpFinder/i18n";

const emit = defineEmits(["toggle"]);

const props = defineProps({
  count: {
    type: Number,
    required: true,
  },
  expanded: {
    type: Boolean,
    default: false,
  },
  /** The region the toggle shows and hides. */
  controls: {
    type: Object,
    default: undefined,
  },
});

const label = computed(() => i18n.global.t("results.more_locations_count", { count: props.count }, props.count));
const ariaExpanded = computed(() => String(props.expanded));
const classModifiers = computed(() => ({ "--expanded": props.expanded }));

const button = useTemplateRef("button");

useAriaControls(button, () => props.controls);

function handleClick() {
  emit("toggle");
}
</script>

<style lang="scss" scoped>
.sp-finder-result-other-locations-toggle {
  --sp-comp-button-bg-color: var(
    --sp-comp-finder-result-other-locations-toggle-background,
    var(--sp-sys-color-surface-variant)
  );
  --sp-comp-button-text-color: var(
    --sp-comp-finder-result-other-locations-toggle-color,
    var(--sp-sys-color-on-surface)
  );
  --sp-comp-button-border-radius: var(
    --sp-comp-finder-result-other-locations-toggle-border-radius,
    var(--sp-ref-border-radius-full)
  );
  --sp-comp-button-small-font-short: var(--sp-sys-typescale-body-short);
  --sp-comp-button-gap: var(--sp-ref-scale-4);
}

.sp-finder-result-other-locations-toggle.--expanded .sp-finder-result-other-locations-toggle__icon {
  rotate: 180deg;
}
</style>
